"use client";

import productData from "@/data/productData.json";
import { ProductPlanDetails } from "@/types/product";
import i18n from "@/lib/i18n"; // Import i18n instance

const typedProductData = productData as any;

export const getTodayAtMidnight = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
};

export interface ProductVariant {
  id: string;
  name: string;
  description: string;
  priceFactor: number;
  details: ProductPlanDetails;
}

export const createProductVariant = (bundleId: "s" | "m" | "l"): ProductVariant => {
  const productDetails = typedProductData.v1[bundleId];
  const baseSumInsured = typedProductData.v1.s.disease.sum_insured;

  let nameKey: string;
  let descriptionKey: string;

  switch (bundleId) {
    case "s":
      nameKey = "priceCustomization.planNames.basic";
      descriptionKey = "priceCustomization.planNames.basicSubtitle";
      break;
    case "m":
      nameKey = "priceCustomization.planNames.standard";
      descriptionKey = "priceCustomization.planNames.standardSubtitle";
      break;
    case "l":
      nameKey = "priceCustomization.planNames.premium";
      descriptionKey = "priceCustomization.planNames.premiumSubtitle";
      break;
    default:
      nameKey = "";
      descriptionKey = "";
  }

  return {
    id: bundleId,
    name: i18n.t(nameKey),
    description: i18n.t(descriptionKey),
    priceFactor: productDetails.disease.sum_insured / baseSumInsured,
    details: productDetails,
  };
};